<template>
    <b-button class="bt bt-profil" :to="link">
      <span class="left" >
        <span>
          <font-awesome-icon :icon="['fas', 'user']" />
        </span>
        {{title}}
      </span>

      <span class="right">
        <font-awesome-icon :icon="['far', 'chevron-right']" />
      </span>
    </b-button>
</template>


<script>

export default {
name:"btProfil",
  props:{
    link:{
      type:String,
      default:'#'
      },
    title:{
      type:String,
      default:'Voir le profil'
      }
  },
data(){
  return {
  }
},
mounted () {
}
}
</script>